<template>
	<div>
		<swiper ref="mySwiper" :options="swiperOption">
			<swiper-slide v-for="row in slides" :key="row.resource">
				<img v-show="row.type === 'img'" :src="row.resource" class="eyecatch">
				<a v-show="row.type === 'link'" :href="row.url" target="_blank"><img :src="row.resource" class="eyecatch"></a>
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>

		<h1>名古屋のキャンピングカーシェア</h1>

		<div class="description">
			ゴーキャン！ライオンのキャンプ社長だ！<br class="_sp"><br class="_pc">キャンピングカーをみんなに使ってもらいたくて、<br class="_sp">シェアを始めたぜ！<br class="_pc">キャンピングカーなら、<br class="_sp">１人でも、仲間とでも、カップルとでも、家族でも、<br class="_sp">気に入いった場所、<br class="_pc">行きたいところに<br class="_sp">サクッといって寝泊りすることが可能だ！
		</div>

		<div class="wrapper">
			<!--
			<div class="video-title">人気ユーチューバー yudai kawase様に<br class="_sp">弊社ラクーンⅡをご紹介頂きました！</div>
			<div class="video">
				<iframe src="https://www.youtube.com/embed/INFp29mnvh0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
			-->

			<!--
			<a href="https://blog.gocam.jp/?p=469" target="_blank"><img class="campaign" src="../assets/top/share_banner.png" alt=""></a>
			-->

			<a href="https://blog.gocam.jp/" target="_blank"><img class="campaign" src="../assets/top/blog_banner.png" alt=""></a>

			<ul class="usage">
				<li>
					<img class="usage-image" src="../assets/top/travel.png" alt="草原に佇むキャンピングカー">
					<img class="usage-image_text" src="../assets/top/travel_text.svg" alt="">
					<img class="usage-image_icon _pc" src="../assets/top/travel_icon.svg" alt="">

					<div class="usage-text_area">
						<div class="usage-title">旅行にGO!</div>
						<div class="usage-description">いつもと違う旅をしたいと思った事はありませんか？マイカー、電車、飛行機どれも楽しいと思います。ただ、ホテルなどの宿泊先を気にすることなく、好きな時間に好きな場所へ気軽に移動できる身軽さはキャンピングカーしかありません！さぁあなたも時間や場所に縛られない自由な旅を経験してみませんか？</div>
					</div>
				</li>

				<li>
					<img class="usage-image" src="../assets/top/friend.png" alt="友だちとキャンピングカーを運転">
					<img class="usage-image_text" src="../assets/top/friend_text.svg" alt="">
					<img class="usage-image_icon _pc" src="../assets/top/friend_icon.svg" alt="">

					<div class="usage-text_area">
						<div class="usage-title">友達彼女とGO!</div>
						<div class="usage-description">気の合う仲間と、大好きな彼氏彼女とキャンピングカーでドライブしてみませんか？途中休憩は外に出る事なく持ち込んだドリンクや食べ物でテーブルを囲んでワイワイガヤガヤ。素晴らしい仲間といけばきっといつもと違ったものになる事でしょう。</div>
					</div>
				</li>

				<li>
					<img class="usage-image" src="../assets/top/telework.png" alt="テレワークでノートPC作業">
					<img class="usage-image_text" src="../assets/top/telework_text.svg" alt="">
					<img class="usage-image_icon _pc" src="../assets/top/telework_icon.svg" alt="">

					<div class="usage-text_area">
						<div class="usage-title">仕事を好きな場所でGO!</div>
						<div class="usage-description">2016年に政府が「働き方改革」を掲げ、最近よく耳にするテレワーク。英語でtelework「tele = 離れた所」と「work = 働く」の2つの単語を組み合わせた造語。そこで、毎日自宅で仕事も良いのですが、たまにはキャンピングカーの中で好きな場所で外で気持ちよく仕事をしてみませんか？意外なアイデアが出ちゃうかも！？</div>
					</div>
				</li>

				<li>
					<img class="usage-image" src="../assets/top/children.png" alt="キャンピングカーのソファで子供と遊ぶ">
					<img class="usage-image_text" src="../assets/top/children_text.svg" alt="">
					<img class="usage-image_icon _pc" src="../assets/top/children_icon.svg" alt="">

					<div class="usage-text_area">
						<div class="usage-title">子供と秘密基地でGO!</div>
						<div class="usage-description">子供にいつもと違う景色を見せてあげましょう！海に山に、またどこでもない場所でもキャンピングカーで行けば世界が変わり子供の笑顔も倍増かも！？お菓子やジュースを持ち込んで一緒にゲームをやったり、勉強を教えたり、楽器の練習をしたり色んな使い方ができます！</div>
					</div>
				</li>
			</ul>

			<div id="calendar" class="gcalendar">
				<div class="gcalendar-title">キャンピングカー空車状況</div>
				<p style="color:red">予定が入っている日はご予約不可となります</p>
				<iframe src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FTokyo&showTitle=0&showNav=1&showDate=1&showPrint=0&showTabs=0&showCalendars=0&showTz=0&src=Z29jYW1qcEBnbWFpbC5jb20&src=anBzdGFydG9yYUBnbWFpbC5jb20&color=%23039BE5&color=%23C0CA33" style="border-width:0" width="800" height="600" frameborder="0" scrolling="no"></iframe>
			</div>

			<a class="reserve" href="/contact">車両を予約</a>

			<a class="twitter-banner banner" href="https://twitter.com/gocamjp" target="_blank"><img src="../assets/top/twitter_banner.svg" alt=""></a>
			<p style="margin-top: 36px;font-size: 16px; font-weight:bold">弊社ラクーン2の検証動画を<br class="_sp">YouTubeで絶賛公開中！</p>
			<a class="twitter-banner banner" style="margin-top: 5px;" href="https://www.youtube.com/channel/UChgqHrdJfV4IO7SGuBoUuEg" target="_blank"><img class="campaign" style="margin-top: 0;" src="../assets/top/gorock_banner.png" alt=""></a>

			<!--
			<img class="cashless" src="../assets/top/cashless.svg" alt="">
			-->
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import "@/scss/style.scss";
@import "@/scss/page/_top.scss";

</style>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import isMobile from 'ismobilejs'

export default {
	name: 'Top',
	components: {
		Swiper,
		SwiperSlide,
	},
	data () {
		return {
			slides: [],
			swiperOption: {},
		}
	},
	created() {
		if (!isMobile().any) {
			this.slides = [
				{
					type: 'img',
					resource: require('@/assets/top/slide_pc_6.png'),
					url: '',
				},
				//{
				//	type: 'img',
				//	resource: require('@/assets/top/slide_pc_5.jpg'),
				//	url: '',
				//},
				{
					type: 'img',
					resource: require('@/assets/top/slide_pc_2.png'),
					url: '',
				},
				{
					type: 'img',
					resource: require('@/assets/top/slide_pc_3.png'),
					url: '',
				},
				{
					type: 'link',
					resource: require('@/assets/top/slide_pc_4.png'),
					url: 'https://blog.gocam.jp/?p=347',
				},
			];
		} else {
			this.slides = [
				{
					type: 'img',
					resource: require('@/assets/top/slide_sp_6.png'),
					url: '',
				},
				//{
				//	type: 'img',
				//	resource: require('@/assets/top/slide_sp_5.jpg'),
				//	url: '',
				//},
				{
					type: 'img',
					resource: require('@/assets/top/slide_sp_2.png'),
					url: '',
				},
				{
					type: 'img',
					resource: require('@/assets/top/slide_sp_3.png'),
					url: '',
				},
				{
					type: 'link',
					resource: require('@/assets/top/slide_sp_4.png'),
					url: 'https://blog.gocam.jp/?p=347',
				},
			];
		}

		this.swiperOption = {
			pagination: {
				el: '.swiper-pagination'
			},
			effect: 'fade',
			autoplay: {
				delay: 5000,
			},
			speed: 1500,
			//navigation: {
			//	nextEl: '.swiper-button-next',
			//	prevEl: '.swiper-button-prev'
			//},
		};
	},
	mounted() {
	},
	watch: {
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.$swiper
		}
	},
	methods: {
	}
}
</script>
